import * as Sentry from '@sentry/browser';
import { SentryConfig } from '../clientsdk/observability/types-sentry';

export function bootstrapSentry(sentry: SentryConfig) {
    const {
        dsn,
        allowSessionReplay,
        replaysOnErrorSampleRate,
        replaysSessionSampleRate,
        environment,
    } = sentry;
    Sentry.init({
        dsn,
        environment,
        integrations: [
            Sentry.browserTracingIntegration(),
            ...(allowSessionReplay ? [Sentry.replayIntegration()] : []),
        ],

        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for tracing.
        // We recommend adjusting this value in production
        // Learn more at
        // https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
        // tracesSampleRate: 1.0,

        // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
        // tracePropagationTargets: [
        //     'localhost',
        //     /^https:\/\/yourserver\.io\/api/,
        // ],

        // https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
        replaysSessionSampleRate,
        replaysOnErrorSampleRate,
    });
}
